import React from 'react';
import { PAGE, REFERRAL_STATUS } from 'placement/const';
import { ReferralPageAction } from 'placement/reducers/referralPage';
import { useQuery, gql } from '@apollo/client';
import { Referral } from 'placement/domains';
import { ErrorDisplay } from 'common';

type MatchSubmitButtonProps = {
    page: PAGE;
    dispatch: React.Dispatch<ReferralPageAction>,
    selectedOfferGuids: Array<String>,
}
export const SELECTED_REFERRAL_QUERY = gql`
    query ($status: [String]!){
        referralQuery(
            first: 1000,
            after: "",
            params: {
                status: $status,
                offerSelectedOnly: true,
                hasOfferOnly: true
            }){
                edges{
                    node{
                        id
                        guid
                        matchedOffer{
                            id
                            guid
                        }
                    }
                }
            }
        referralCount(
            params: {
                status: $status,
                offerSelectedOnly: true,
                hasOfferOnly: true
            }
        )
    }
`
type ReferralQueryResponse = {
    edges: Array<ReferralNode>;
}

type ReferralNode = {
    node: Referral
}

export function MatchSubmitButton({ page, dispatch, selectedOfferGuids }: MatchSubmitButtonProps) {

    const { loading, data, error } = useQuery<{ referralQuery: ReferralQueryResponse, referralCount: number }, {}>(SELECTED_REFERRAL_QUERY, {
        variables: {
            status: [REFERRAL_STATUS.AVAILABLE, REFERRAL_STATUS.PROVIDER_REQUEST]
        },
        fetchPolicy: 'no-cache',
        onCompleted: () => {
            let selectedOfferGuids: string[] = [];
            if (data && data.referralQuery.edges.length > 0) {
                selectedOfferGuids = data.referralQuery.edges.map((edge) => edge.node.matchedOffer?.guid ?? '');
            }
            dispatch({ type: 'SET_FETCH_SELECTED_OFFER_DONE', selectedOfferGuids });
        }
    })
    const showMatchModal = () => {
        dispatch({ type: 'SET_SHOW_MATCH_MODAL' });
    }
    let confirmText = `Match (${selectedOfferGuids.length})`
    let loadingTextCss = '';
    let matchDisabled = true;
    if (loading) {
        loadingTextCss = 'loading-text';
        confirmText = 'Loading';
    }

    if (error) {
        return <ErrorDisplay error={error} title="Error loading selected referrals" />;
    }

    if (selectedOfferGuids.length > 0) {
        matchDisabled = false;
    }

    return (
        <React.Fragment>
            {
                page === PAGE.PROVIDER_REQUEST &&
                <button className={`px-6 py-2 text-white text-bold leading none ${loadingTextCss}
                                rounded bg-atlantis-200 hover:bg-atlantis-300 ${matchDisabled ? 'opacity-25 cursor-not-allowed' : ''}`}
                    onClick={showMatchModal}
                    disabled={matchDisabled}>
                    {confirmText}
                </button>
            }
        </React.Fragment>
    );
}
